import { type } from "os";
import React, { useState } from "react";
import BubbleLoader from "../../_general/BubbleLoader";

export interface ButtonProps {
  type: "primary" | "secondary";
  size: "xs" | "sm" | "md" | "lg";
  rounded?: boolean;
  block?: boolean;
  Icon?: any;
  disabled?: boolean;
  loading?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string,
  color?: string,
  variant?: 'contained' | 'outlined' | 'normal'
}
const Button: React.FC<ButtonProps> = (props) => {
  const {
    children,
    Icon,
    type,
    rounded,
    block,
    disabled,
    loading,
    size,
    onClick,
    className,
    variant = 'contained'
  } = props;

  let classList = [
    "relative flex flex-row justify-center items-center",
    //"transform transition-transform hover:scale-105"
  ];
  let minWidth = 194;
  if (type === "primary" && variant === 'contained') classList.push("bg-primary")
  if (type === "secondary" && !className?.includes("bg") && variant === 'contained') classList.push("bg-secondary");
  classList.push("px-4");
  classList.push("disabled:opacity-25");
  rounded ? classList.push("rounded-full") : classList.push("rounded-md");

  if (block) classList.push("w-full");
  if (loading) classList.push("space-x-0");
  if(variant === 'contained') classList.push("text-white")
  if(variant === 'outlined') classList.push('bg-transparent border-2')
  if(variant === 'outlined' && type === 'secondary') classList.push('text-secondary dark:text-highlight-yellow border-secondary dark:border-highlight-yellow')
  if(variant === 'normal') classList.push('bg-transparent')

  if (className) classList.push(className)
  switch (size) {
    case "xs":
      classList.push('py-1');
      minWidth = 0;
      break;
    case "sm":
      classList.push('p-2');
      minWidth = 0;
      break;
    case "md":
      classList.push('py-3 md:py-6');
      break;
    case "lg":
      classList.push('py-3');
      break;
  }

  return (
    <button
      className={classList.join(" ")}
      onClick={onClick}
      style={{ minWidth }}
      disabled={disabled}
    >
      <div className={`flex flex-row ${loading ? "invisible" : ""}`}>
        <span className={Icon ? "pr-2" : ""}>{Icon}</span>
        <span>{children}</span>
      </div>
      <span className={loading ? "absolute" : "hidden"}>
        <BubbleLoader color="white" />
      </span>
    </button>
  );
};

Button.defaultProps = {
  type: "primary",
  block: false,
  size: "md",
};

export default Button;
